module.exports = __webpack_public_path__ + "static/media/img81.604dbd79.jpg";